import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ltx/phase-i/medical-history/medicalTreatment";

import {
	FieldData,
	FieldGroupListData,
	FieldsetData
} from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	medicalTreatment: {
		id: "form.medical_treatment",
		defaultMessage: "Gyógyszeres kezelés"
	},
	drugType: {
		id: "form.medical_treatment.drug_type",
		defaultMessage: "Gyógyszer"
	},
	drugTypeName: {
		id: "form.medical_treatment.drug_type_name",
		defaultMessage: "Gyógyszer neve"
	},
	drugTypeDose: {
		id: "form.medical_treatment.drug_type_dose",
		defaultMessage: "Dózis"
	}
});

const fields: { [key: string]: FieldGroupListData | FieldData } = {
	drugType: {
		type: "field-group-list",
		path: ["drugType"],
		label: messages.drugType,
		rows: [
			{
				columns: [
					{
						width: 6,
						field: {
							type: "field",
							path: ["drugTypeName"],
							label: messages.drugTypeName,
							errorMessages: genericErrorMessages,
							input: { type: "input", props: { type: "text" } }
						}
					},
					{
						width: 6,
						field: {
							type: "field",
							path: ["drugTypeDose"],
							label: messages.drugTypeDose,
							errorMessages: genericErrorMessages,
							input: { type: "input", props: { type: "text" } }
						}
					}
				]
			}
		]
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.drugType }] }]
};

export const node: LeafNode = {
	id: "medicalTreatment",
	value: {
		title: messages.medicalTreatment,
		validator,
		fieldset,
		isImportant: true,
		applyCurrentDate: true
	}
};
